module.exports = __webpack_public_path__ + "29dd051d4e34917b6e0f1ab5a82cb7f7.svg";